import { render } from "./Test.vue?vue&type=template&id=8ba9e914&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=8ba9e914&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba9e914"]])

export default __exports__